import React from "react";
import { Card, CardBody, CardHeader, Col, Row, Form } from "reactstrap";
import Joi from "joi-browser";
import DefaultForm from "../common/defaultForm";
import userService from "../services/userService";
import { toast } from "react-toastify";
import Placeholder from "../common/placeholder";
import { NavigateFunction, Params, useNavigate, useParams } from "react-router-dom";


interface userFormProps {
  history: NavigateFunction,
  params: Readonly<Params<string>>,

}
class UserForm extends DefaultForm<userFormProps> {
  state = {
    data: { username: "", fullName: "", role: "", password: "", id: undefined, cpf: "" },
    errors: {},
    roles: [
      { id: "Coordenador", name: "Coordenador" },
      { id: "Assistente", name: "Assistente" },
      { id: "FAEPI", name: "FAEPI" },
      { id: "FAEPI-Assistente", name: "FAEPI-Assistente" },

    ],
    submitting: false,
    ready: false,
  };

  schema = {
    id: Joi.string(),
    username: Joi.string().required().email().label("E-mail"),
    fullName: Joi.string().required().label("Nome Completo"),
    cpf: Joi.string().required().label("CPF"),
    role: Joi.string().required().label("Perfil"),
    password: Joi.string().allow("").min(6).label("Senha"),
  };

  async populateUser() {
    try {
      const userId = this.props.params.id;
      if (userId === "novo") {
        this.schema.password = Joi.string().required().min(6).label("Senha");
        return;
      }

      const { data: user } = await userService.getUser(userId);
      delete user.key;
      this.setState({ data: user });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        this.props.history("/404");
      }
    }
  }

  async componentDidMount() {
    const userPromise = this.populateUser();
    await userPromise;
    this.setState({ ready: true });
  }

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await userService.saveUser(data);
      if (data.id) {
        toast.success("Sucesso! Usuário Atualizado.");
      } else {
        toast.success("Sucesso! Usuário Cadastrado.");
      }

      this.props.history("/gerenciamento/usuarios");
    } catch (ex) {
      this.setState({ submitting: false });
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        this.setState({ errors: ex.response.data });
      }
    }
  };

  goBack = () => {
    this.props.history(-1);
  };

  render() {
    const isNew = this.props.params.id === "novo";

    return (
      <div className="animated fadeIn w-full  overflow-y-auto overflow-x-hidden">
        <Row>
          <Col lg={6}>
            <Card>
              <Placeholder ready={this.state.ready}>
                <CardHeader className="bg-light">
                  <i className="fa fa-user pr-1" />
                  {isNew
                    ? "Cadastrar novo Usuário"
                    : `Editar Usuário: ${this.state.data.username}`}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={this.handleSubmit}>
                    {this.renderInput("username", "E-mail")}
                    {this.renderInput("fullName", "Nome Completo")}
                    {this.renderInput("cpf", "CPF")}

                    {this.renderSelect("role", this.state.roles, "Perfil")}
                    {this.renderInput("password", "Senha", "password")}
                    {this.renderButton("Salvar")}
                    <button
                      type="button"
                      onClick={this.goBack}
                      className={"btn btn-secondary ml-3"}
                    >
                      Voltar
                    </button>
                  </Form>
                </CardBody>
              </Placeholder>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default (props) => (
  <UserForm history={useNavigate()} params={useParams()} />
);